<template>

  <UiTabs
    class="nt-tabs"
    :tabs="tabs"
    :acttab="modelValue"
    @choose="choose"
    :centered="false"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { NotificationChannel } from '@/types/notification'

import UiTabs from '~/components/ui/Tabs.vue'

const props = defineProps<{
  modelValue: NotificationChannel
  counts: Record<NotificationChannel, number>
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: NotificationChannel): void
}>()

const tabs = computed(() => [
  { id: NotificationChannel.Direct, name: 'For You', link: '', icon: '', count: props.counts.direct < 0 ? 0 : props.counts.direct },
  { id: NotificationChannel.Following, name: 'Following', link: '', icon: '', count: props.counts.following < 0 ? 0 : props.counts.following },
  // { id: NotificationChannel.Community, name: 'Community', link: '#', icon: '', count: props.counts.community },
])

const choose = (id: string) => emit('update:modelValue', id as any)
</script>

<style scoped>
.nt-tabs :deep(.menu_item.act){
  border-bottom-color:var(--accent);
  border-bottom-width:2px;
}
</style> 